/* Plant Doctor — chat UI, voice notes, soft lead gate. Vanilla JS.
   Fixture mode while data-worker-url is empty. */
(function () {
  'use strict';

  var root, cfg, state;

  var FIXTURE = {
    session_id: null,
    reply: {
      acknowledgement: 'Yellowing lower leaves on a money plant that gets water every day — got it.',
      diagnosis: 'This looks like overwatering. Money plants only need water when the top inch of soil is dry — daily watering suffocates the roots, and the plant sheds its lower leaves first.',
      confidence: 'high',
      cause: 'Watering on a fixed daily schedule, instead of by soil feel, is the most common cause of yellowing we see in Pakistani homes.',
      immediate_actions: [
        'Stop watering until the top 2–3cm of soil is fully dry — usually 4–6 days.',
        'Move the pot to bright, indirect light with some air movement.',
        'Remove fully yellow leaves; they will not recover.'
      ],
      recommended_products: [
        {
          handle: 'the-master-blend-all-in-one-organic-soil-food-pest-guard',
          reason: 'Once the soil dries out, your plant needs gentle nutrition to regrow — without burn risk on stressed roots.',
          how_to_use: '1–2 tablespoons worked into the topsoil, then water once. Repeat every 4–6 weeks.'
        }
      ],
      follow_up_question: null,
      escalate_to_human: false
    }
  };

  function $(id) { return document.getElementById(id); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function track(ev, p) { try { if (window.gtag) window.gtag('event', ev, p || {}); } catch (e) {} }
  function waLink(text) { return 'https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent(text); }

  /* ---------- thread helpers ---------- */
  function bubble(role, html) {
    var el = document.createElement('div');
    el.className = 'pd-bub ' + (role === 'user' ? 'user' : 'doc');
    el.innerHTML = html;
    $('pd-thread').appendChild(el);
    el.scrollIntoView({ behavior: 'smooth', block: 'end' });
    return el;
  }

  function typingOn() {
    state.typingEl = bubble('doc', '<span class="pd-typing"><span></span><span></span><span></span></span>');
  }
  function typingOff() {
    if (state.typingEl) { state.typingEl.remove(); state.typingEl = null; }
  }

  /* ---------- media ---------- */
  function prepareImage(file) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        var scale = Math.min(1, 1024 / Math.max(img.width, img.height));
        var c = document.createElement('canvas');
        c.width = Math.round(img.width * scale);
        c.height = Math.round(img.height * scale);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        resolve(c.toDataURL('image/webp', 0.8));
      };
      img.onerror = function () { resolve(null); };
      img.src = URL.createObjectURL(file);
    });
  }

  function clearAttachments() {
    state.image = null;
    state.audio = null;
    $('pd-photo-preview').hidden = true;
    $('pd-audio-chip').hidden = true;
    $('pd-attach-preview').hidden = true;
    $('pd-photo').value = '';
  }

  /* voice notes — MediaRecorder, 60s cap */
  function startRecording() {
    if (!navigator.mediaDevices || !window.MediaRecorder) {
      bubble('doc', '<p>Voice notes is browser par support nahi hain — please likh kar bhejein ya WhatsApp karein.</p>');
      return;
    }
    navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
      var mime = MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm'
               : MediaRecorder.isTypeSupported('audio/mp4') ? 'audio/mp4' : '';
      var rec = new MediaRecorder(stream, mime ? { mimeType: mime } : undefined);
      var chunks = [];
      rec.ondataavailable = function (e) { if (e.data.size) chunks.push(e.data); };
      rec.onstop = function () {
        stream.getTracks().forEach(function (t) { t.stop(); });
        var blob = new Blob(chunks, { type: rec.mimeType || 'audio/webm' });
        if (blob.size > 1024 * 1024) {
          bubble('doc', '<p>Voice note bohat lambi hai — 60 second se kam rakhein.</p>');
        } else {
          var fr = new FileReader();
          fr.onload = function () {
            state.audio = fr.result;
            $('pd-audio-chip').hidden = false;
            $('pd-attach-preview').hidden = false;
          };
          fr.readAsDataURL(blob);
        }
        micIdle();
      };
      state.recorder = rec;
      rec.start();
      state.recStart = Date.now();
      $('pd-mic').classList.add('rec');
      $('pd-rec-timer').hidden = false;
      state.recTimer = setInterval(function () {
        var s = Math.floor((Date.now() - state.recStart) / 1000);
        $('pd-rec-timer').textContent = Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
        if (s >= 60) stopRecording();
      }, 250);
    }).catch(function () {
      bubble('doc', '<p>Mic ki ijazat nahi mili — browser settings mein microphone allow karein.</p>');
    });
  }
  function stopRecording() {
    if (state.recorder && state.recorder.state !== 'inactive') state.recorder.stop();
  }
  function micIdle() {
    clearInterval(state.recTimer);
    $('pd-mic').classList.remove('rec');
    $('pd-rec-timer').hidden = true;
    $('pd-rec-timer').textContent = '0:00';
    state.recorder = null;
  }

  /* ---------- rendering the reply ---------- */
  function renderReply(reply) {
    var html = '';
    if (reply.acknowledgement) html += '<p>' + esc(reply.acknowledgement) + '</p>';
    html += '<p class="diag">' + esc(reply.diagnosis) + '</p>';
    if (reply.confidence) html += '<span class="conf">Confidence: ' + esc(reply.confidence) + '</span>';
    if (reply.cause) html += '<p>' + esc(reply.cause) + '</p>';
    if (reply.immediate_actions && reply.immediate_actions.length) {
      html += '<p class="sect">Do this first — free</p><ul>';
      reply.immediate_actions.forEach(function (a) { html += '<li>' + esc(a) + '</li>'; });
      html += '</ul>';
    }
    if (reply.recommended_products && reply.recommended_products.length) {
      html += '<p class="sect">What will fix it</p><div class="pd-prods"></div>';
    }
    if (reply.follow_up_question) html += '<p class="followq">' + esc(reply.follow_up_question) + '</p>';

    var bub = bubble('doc', html);
    var prodWrap = bub.querySelector('.pd-prods');
    if (prodWrap) {
      reply.recommended_products.forEach(function (rec) { renderProduct(rec, prodWrap); });
      track('pd_product_shown', { handles: reply.recommended_products.map(function (r) { return r.handle; }).join(',') });
    }

    var waMsg = 'Assalam-o-Alaikum! Plant Doctor se aya hoon' + (state.sessionId ? ' (session ' + state.sessionId.slice(0, 8) + ')' : '');
    var waRow = document.createElement('div');
    waRow.className = 'pd-wa-row';
    waRow.innerHTML = '<a href="' + waLink(waMsg) + '" target="_blank" rel="noopener">💬 WhatsApp par baat karein</a>';
    waRow.querySelector('a').addEventListener('click', function () { track('pd_whatsapp'); });
    $('pd-thread').appendChild(waRow);
    waRow.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }

  function renderProduct(rec, wrap) {
    fetch('/products/' + rec.handle + '.js')
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        var card = document.createElement('div');
        card.className = 'pd-prod';
        var img = p.featured_image ? '<img src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<span></span>';
        card.innerHTML =
          img +
          '<div><p class="nm">' + esc(p.title.split('|')[0].split(' — ')[0].trim()) + '</p>' +
          '<p class="pr">Rs. ' + Math.round(p.price / 100).toLocaleString() + '</p>' +
          '<p class="rsn">' + esc(rec.reason) + '</p>' +
          '<p class="how">' + esc(rec.how_to_use) + '</p>' +
          '<button type="button">Add to cart</button></div>';
        card.querySelector('button').addEventListener('click', function () { addToCart(p, card); });
        wrap.appendChild(card);
      })
      .catch(function () {});
  }

  function addToCart(p, card) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: p.variants[0].id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Plant Doctor Session': state.sessionId || 'fixture' } })
        });
        card.querySelector('button').outerHTML = '<span class="added">Added ✓ &nbsp;<a href="/cart">View cart</a></span>';
        track('pd_add_to_cart', { handle: p.handle });
        beacon({ event: 'added_to_cart' });
      })
      .catch(function () { window.location.href = '/products/' + p.handle; });
  }

  /* ---------- worker ---------- */
  function beacon(payload) {
    if (!cfg.workerUrl || !state.sessionId) return;
    payload.session_id = state.sessionId;
    try {
      navigator.sendBeacon(cfg.workerUrl + '/beacon', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    } catch (e) {
      fetch(cfg.workerUrl + '/beacon', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
    }
  }

  function send() {
    var msg = $('pd-text').value.trim();
    if (!msg && !state.image && !state.audio) return;

    var userHtml = msg ? '<p>' + esc(msg) + '</p>' : '';
    if (state.image) userHtml += '<img src="' + state.image + '" alt="photo">';
    if (state.audio) userHtml += '<span class="pd-voicechip">🎤 Voice note</span><audio controls src="' + state.audio + '"></audio>';
    bubble('user', userHtml);

    var image = state.image, audio = state.audio;
    $('pd-text').value = '';
    clearAttachments();
    $('pd-send').disabled = true;
    typingOn();
    track('pd_start');

    var handle = function (data) {
      typingOff();
      $('pd-send').disabled = false;
      if (data.session_id) state.sessionId = data.session_id;
      var userMemo = (msg || '') + (image ? ' [photo bheji]' : '') + (audio ? ' [voice note bheji]' : '');
      var docMemo = [data.reply.diagnosis, data.reply.cause, data.reply.follow_up_question]
        .filter(Boolean).join(' ');
      state.history.push({ role: 'user', content: userMemo.trim() });
      state.history.push({ role: 'assistant', content: docMemo });
      state.history = state.history.slice(-6);
      persist();
      track('pd_diagnosis', { confidence: data.reply.confidence, plant_type: data.reply.plant_type || '' });

      if (!state.gateDone) {
        state.pendingReply = data.reply;
        $('pd-gate').hidden = false;
      } else {
        renderReply(data.reply);
      }
    };
    var fail = function (friendly) {
      typingOff();
      $('pd-send').disabled = false;
      bubble('doc', '<p>' + esc(friendly || 'Kuch masla ho gaya — WhatsApp par photo bhej dein, hum khud jawab denge.') + '</p>');
      var row = document.createElement('div');
      row.className = 'pd-wa-row';
      row.innerHTML = '<a href="' + waLink('Assalam-o-Alaikum! Plant Doctor se madad chahiye') + '" target="_blank" rel="noopener">💬 WhatsApp karein</a>';
      $('pd-thread').appendChild(row);
    };

    if (!cfg.workerUrl) {
      setTimeout(function () { handle(JSON.parse(JSON.stringify(FIXTURE))); }, 1600);
      return;
    }

    var token = '';
    try { token = window.turnstile ? window.turnstile.getResponse() : ''; } catch (e) {}

    fetch(cfg.workerUrl + '/diagnose', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id: state.sessionId, message: msg, image: image, audio: audio,
        turnstile_token: token, history: state.history, referrer: document.referrer
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { s: r.status, j: j }; }); })
      .then(function (res) {
        if (res.s === 429) return fail(res.j.friendly);
        if (!res.j.reply) throw 0;
        handle(res.j);
      })
      .catch(function () { fail(null); });
  }

  function closeGate(saveLead) {
    if (saveLead) {
      var contact = $('pd-gate-contact').value.trim();
      if (contact) {
        beacon({ event: 'lead', name: $('pd-gate-name').value.trim(), contact: contact, consent: $('pd-gate-consent').checked });
        track('pd_lead');
      }
    }
    state.gateDone = true;
    persist();
    $('pd-gate').hidden = true;
    if (state.pendingReply) { renderReply(state.pendingReply); state.pendingReply = null; }
  }

  /* keep session + memory across page reloads (same tab) */
  function persist() {
    try {
      sessionStorage.setItem('pd_state', JSON.stringify({
        sessionId: state.sessionId, history: state.history, gateDone: state.gateDone
      }));
    } catch (e) {}
  }
  function restore() {
    try {
      var saved = JSON.parse(sessionStorage.getItem('pd_state') || 'null');
      if (saved) {
        state.sessionId = saved.sessionId || null;
        state.history = saved.history || [];
        state.gateDone = !!saved.gateDone;
      }
    } catch (e) {}
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    root = $('pd-root');
    if (!root) return;
    cfg = { workerUrl: (root.dataset.workerUrl || '').replace(/\/$/, ''), whatsapp: root.dataset.whatsapp || '923709145600' };
    state = { sessionId: null, history: [], image: null, audio: null, gateDone: false, pendingReply: null, typingEl: null, recorder: null };
    restore();

    $('pd-photo').addEventListener('change', function () {
      var f = this.files[0];
      if (!f) return;
      prepareImage(f).then(function (dataUrl) {
        if (!dataUrl) return;
        state.image = dataUrl;
        $('pd-photo-preview').src = dataUrl;
        $('pd-photo-preview').hidden = false;
        $('pd-attach-preview').hidden = false;
      });
    });

    $('pd-attach-clear').addEventListener('click', clearAttachments);
    $('pd-mic').addEventListener('click', function () {
      if (state.recorder) stopRecording(); else startRecording();
    });
    $('pd-send').addEventListener('click', send);
    $('pd-text').addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
    });
    $('pd-text').addEventListener('input', function () {
      this.style.height = 'auto';
      this.style.height = Math.min(this.scrollHeight, 110) + 'px';
    });

    $('pd-gate-show').addEventListener('click', function () { closeGate(true); });
    $('pd-gate-skip').addEventListener('click', function () { closeGate(false); });
  });
})();
